/* Candy4U gift card page (sections/c4u-gift-card.liquid).
   - Amount: shows that amount's card and price, and puts ?variant= in the address like the product page.
   - "Send it straight to them" is always open (Arsalan 2026-10-27: "closable na ho"). With their email filled in, Shopify's
     recipient flag, the fields and the time zone offset are posted (Dawn's assets/recipient-form.js rules, the no-JS
     "if_present" flag off); with it empty and nothing else typed, none of them are, so the card comes to the buyer.
     "When should it arrive?" shows the date field for "Pick a date"; the note ideas fill the message.
   - Add to basket: /cart/add.js with the form as it stands, then candy:cart:added opens the basket drawer
     (sections/candy-cart-drawer.liquid). Shopify checks the recipient details and its errors land under each field. */
(function(){
  var KEYS = ['email', 'name', 'send_on', 'message'];
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* the splash colours: the theme's magenta, violet and pink, plus candy gold, blue and white */
  var SPLASH = ['#DE24B6', '#FF6FD8', '#B13BFF', '#FFD166', '#7AD7FF', '#FFFFFF', '#EF00B4'];
  /* Shopify's own errors can be half a sentence ("is invalid"), so those get the field's name in front */
  var NAMES = { email: 'Their email', name: 'Their name', send_on: 'The send date', message: 'The message' };
  /* optional recipient fields left empty are not sent, so the order carries no blank "Send on" line */
  var OPTIONAL = ['properties[Recipient name]', 'properties[Message]', 'properties[Send on]'];
  /* with no email, none of the recipient's part is sent and the card goes to the buyer */
  var RECIPIENT = ['properties[__shopify_send_gift_card_to_recipient]', 'properties[Recipient email]',
    'properties[Recipient name]', 'properties[Message]', 'properties[Send on]', 'properties[__shopify_offset]'];

  function ymd(d){
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  function init(root){
    if(root.hasAttribute('data-c4ugc-ready')) return;
    var form = root.querySelector('[data-c4ugc-form]');
    if(!form) return;
    root.setAttribute('data-c4ugc-ready', '');

    var variants = [];
    try{ variants = JSON.parse(root.querySelector('[data-c4ugc-variants]').textContent); }catch(err){}
    var price = root.querySelector('[data-c4ugc-price]');
    var priceV = root.querySelector('[data-c4ugc-price-v]');
    var stage = root.querySelector('[data-c4ugc-stage]');
    var shown = null;
    var counting = 0;
    var atc = root.querySelector('[data-c4ugc-atc]');
    var atcT = root.querySelector('[data-c4ugc-atc-t]');
    var status = root.querySelector('[data-c4ugc-status]');
    var qtyIn = root.querySelector('[data-c4ugc-qty]');
    var to = root.querySelector('[data-c4ugc-to]');
    var send = root.querySelector('[data-c4ugc-send]');
    var ifPresent = root.querySelector('[data-c4ugc-ifpresent]');
    var offset = root.querySelector('[data-c4ugc-offset]');
    var fields = Array.prototype.slice.call(root.querySelectorAll('[data-c4ugc-in]'));
    var msg = root.querySelector('[data-c4ugc-in="message"]');
    var count = root.querySelector('[data-c4ugc-count]');
    var date = root.querySelector('[data-c4ugc-in="send_on"]');
    var whens = Array.prototype.slice.call(root.querySelectorAll('[data-c4ugc-when]'));
    var idea = '';
    var cartRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var pending = false, addLocked = false, frozen = [];
    var video = window.c4uGiftCardVideo ? window.c4uGiftCardVideo(root, syncAtc) : null;
    function freeze(on){
      if(video) video.lock(on || addLocked);
      if(on){
        frozen = Array.from(form.querySelectorAll('input, textarea, button')).filter(function(el){ return !el.disabled; });
        frozen.forEach(function(el){ el.disabled = true; });
      }else{
        frozen.forEach(function(el){ if(el.isConnected) el.disabled = false; });
        frozen = [];
        drawCal();
      }
    }

    function field(key){ return root.querySelector('[data-c4ugc-in="' + key + '"]'); }
    function errEl(key){ return root.querySelector('[data-c4ugc-err="' + key + '"]'); }
    function setStatus(text, error){
      if(!status) return;
      status.textContent = text || '';
      if(error) status.setAttribute('data-state', 'error'); else status.removeAttribute('data-state');
    }
    function showError(key, text){
      var f = field(key), e = errEl(key);
      if(e){ e.textContent = text; e.hidden = false; }
      if(f) f.setAttribute('aria-invalid', 'true');
    }
    function clearErrors(){
      KEYS.forEach(function(key){
        var f = field(key), e = errEl(key);
        if(e){ e.textContent = ''; e.hidden = true; }
        if(f) f.removeAttribute('aria-invalid');
      });
    }

    function chosen(){
      var r = form.querySelector('input[name="id"]:checked');
      var id = r ? r.value : '';
      for(var i = 0; i < variants.length; i++){ if(String(variants[i].id) === String(id)) return variants[i]; }
      return null;
    }
    function syncAtc(){
      var v = chosen();
      var ok = !!(v && v.available);
      if(atc){ atc.disabled = !ok || pending || addLocked || !!(video && video.busy()); atc.setAttribute('aria-busy', String(pending)); }
      if(atcT) atcT.textContent = addLocked ? 'Review your basket' : pending ? 'Adding to basket...' : video && video.busy() ? 'Preparing video...' : v && !v.available ? 'Sold out' : 'Add to basket';
    }
    /* the price: drops in from above, counts from the old amount to the new one, then splashes where it lands */
    function amountText(cents, like){
      var m = String(like).match(/^(\D*)[\d.,]+(.*)$/);
      var n = (cents / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return m ? m[1] + n + m[2] : n;
    }
    function splash(){
      if(!price) return;
      var box = document.createElement('span');
      box.className = 'c4ugc__splash';
      box.setAttribute('aria-hidden', 'true');
      box.appendChild(document.createElement('b'));
      for(var i = 0; i < 26; i++){
        var bit = document.createElement('i');
        var kind = i % 3;
        if(kind === 1) bit.className = 'c4ugc__drop';
        if(kind === 2) bit.className = 'c4ugc__sprinkle';
        /* mostly outward and upward, like a splash, with a few falling low */
        var a = (i / 26) * Math.PI * 2 + (Math.random() - 0.5) * 0.5;
        var dist = 1.4 + Math.random() * 1.9;
        var x = Math.cos(a) * dist * 1.5, y = Math.sin(a) * dist - 0.35;
        bit.style.setProperty('--x', x.toFixed(2) + 'em');
        bit.style.setProperty('--y', y.toFixed(2) + 'em');
        bit.style.setProperty('--r', (a * 180 / Math.PI + 90).toFixed(0) + 'deg');
        bit.style.setProperty('--s', (0.1 + Math.random() * 0.14).toFixed(2) + 'em');
        bit.style.setProperty('--c', SPLASH[i % SPLASH.length]);
        bit.style.setProperty('--d', (Math.random() * 0.08).toFixed(2) + 's');
        bit.style.setProperty('--t', (0.65 + Math.random() * 0.35).toFixed(2) + 's');
        box.appendChild(bit);
      }
      price.appendChild(box);
      setTimeout(function(){ if(box.parentNode) box.parentNode.removeChild(box); }, 1300);
    }
    function showPrice(v, animate){
      if(!priceV) return;
      var from = shown ? shown.cents : v.cents;
      shown = v;
      if(!animate || REDUCE || from === v.cents){ priceV.textContent = v.price; return; }
      priceV.classList.remove('c4ugc__price-v--drop');
      void priceV.offsetWidth;
      priceV.classList.add('c4ugc__price-v--drop');
      var start = null, run = ++counting, span = 620;
      function step(t){
        if(run !== counting) return;
        if(start === null) start = t;
        var k = Math.min(1, (t - start) / span);
        var e = 1 - Math.pow(1 - k, 3);
        priceV.textContent = k < 1 ? amountText(Math.round(from + (v.cents - from) * e), v.price) : v.price;
        if(k < 1) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
      setTimeout(function(){ if(run === counting) splash(); }, 380);
    }
    function showCard(v, animate){
      root.querySelectorAll('[data-card]').forEach(function(img){
        var on = img.getAttribute('data-card') === String(v.id);
        img.classList.toggle('c4ugc__card--on', on);
        img.classList.remove('c4ugc__card--pop');
        if(on && animate && !REDUCE){ void img.offsetWidth; img.classList.add('c4ugc__card--pop'); }
      });
      root.querySelectorAll('[data-c4ugc-thumb]').forEach(function(b){
        var on = b.getAttribute('data-c4ugc-thumb') === String(v.id);
        b.classList.toggle('c4ugc__thumb--on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if(stage && animate && !REDUCE){
        stage.classList.remove('c4ugc__stage--flash');
        void stage.offsetWidth;
        stage.classList.add('c4ugc__stage--flash');
      }
    }
    function pick(animate){
      var v = chosen();
      if(!v) return;
      showPrice(v, animate);
      showCard(v, animate);
      syncAtc();
      try{
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', u.toString());
      }catch(err){}
    }

    function updateCount(){
      if(!msg || !count) return;
      var max = msg.maxLength > 0 ? msg.maxLength : 200;
      count.textContent = msg.value.length + ' / ' + max;
    }
    function filled(key){
      var f = field(key);
      return !!(f && f.value.trim());
    }
    /* "When should it arrive?": the date field shows for "Pick a date"; "Straight away" empties it */
    function setWhen(v, focus){
      whens.forEach(function(r){ r.checked = r.value === v; });
      if(to){
        to.classList.toggle('c4ugc__to--date', v === 'date');
        to.classList.remove('c4ugc__to--folded');
      }
      if(v !== 'date' && date){
        date.value = '';
        var e = errEl('send_on');
        if(e){ e.hidden = true; e.textContent = ''; }
        date.removeAttribute('aria-invalid');
        view = null;
        drawCal();
        noteDate();
      }
      if(v === 'date' && focus && date){
        var day = calDays && (calDays.querySelector('.c4ugc__cal-day--on') || calDays.querySelector('.c4ugc__cal-day:not([disabled])'));
        if(day) day.focus();
        else{
          date.focus();
          try{ if(date.showPicker) date.showPicker(); }catch(err){}
        }
      }
    }

    /* THE CALENDAR (Arsalan 2026-10-27: "customize the date"). The browser's own date picker cannot take the theme's
       look, so a month grid in the box writes the chosen day into the real date field, which stays in the form, hidden.
       Weeks start on Monday; days before today or past the 90-day limit cannot be picked; arrow keys move by day and
       week. With no JS the plain date field shows instead. */
    var cal = root.querySelector('[data-c4ugc-cal]');
    var calDays = cal && cal.querySelector('[data-c4ugc-cal-days]');
    var calMonth = cal && cal.querySelector('[data-c4ugc-cal-month]');
    var calPrev = cal && cal.querySelector('[data-c4ugc-cal-prev]');
    var calNext = cal && cal.querySelector('[data-c4ugc-cal-next]');
    var whenNote = root.querySelector('[data-c4ugc-when-date]');
    var dateT = root.querySelector('[data-c4ugc-date-t]');
    var dateWord = dateT ? dateT.textContent : '';
    var dateR = whens.filter(function(r){ return r.value === 'date'; })[0];
    var view = null;
    var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    function parse(s){
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
      return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null;
    }
    function dayName(d){ return WEEKDAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
    function noteDate(){
      var d = parse(date && date.value);
      if(whenNote) whenNote.textContent = d ? 'We’ll email it to them on ' + dayName(d) + '.' : 'Pick any day up to 90 days ahead.';
      if(dateT) dateT.textContent = d ? WEEKDAYS[d.getDay()].slice(0, 3) + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()].slice(0, 3) : dateWord;
    }
    /* Arsalan 2026-10-27: once a day is picked the month folds away and the "Pick a date" pill shows the day, like
       "Thu 3 Dec". Pressing the pill again opens the month to change it. */
    function foldCal(fold){
      if(to) to.classList.toggle('c4ugc__to--folded', fold);
      if(fold){ if(dateR) dateR.focus(); }
      else{ view = null; drawCal(date.value); }
    }
    function drawCal(focusKey){
      if(!calDays || !date) return;
      var min = parse(date.min), max = parse(date.max), sel = parse(date.value), today = ymd(new Date());
      var start = sel || min || new Date();
      if(!view) view = new Date(start.getFullYear(), start.getMonth(), 1);
      if(calMonth) calMonth.textContent = MONTHS[view.getMonth()] + ' ' + view.getFullYear();
      var lead = (view.getDay() + 6) % 7;
      var count = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      var html = '';
      for(var i = 0; i < lead; i++) html += '<span class="c4ugc__cal-pad" aria-hidden="true"></span>';
      for(var n = 1; n <= count; n++){
        var day = new Date(view.getFullYear(), view.getMonth(), n), key = ymd(day);
        var off = (min && day < min) || (max && day > max);
        var on = !!sel && key === ymd(sel);
        html += '<button type="button" class="c4ugc__cal-day' + (on ? ' c4ugc__cal-day--on' : '') + (key === today ? ' c4ugc__cal-day--today' : '') +
          '" data-d="' + key + '" aria-label="' + dayName(day) + ' ' + day.getFullYear() + '" aria-pressed="' + on + '" tabindex="-1"' +
          (off ? ' disabled' : '') + '>' + n + '</button>';
      }
      calDays.innerHTML = html;
      /* one day takes Tab: the chosen one, else the first that can be picked */
      var tab = calDays.querySelector('.c4ugc__cal-day--on:not([disabled])') || calDays.querySelector('.c4ugc__cal-day:not([disabled])');
      if(tab) tab.tabIndex = 0;
      var vm = view.getFullYear() * 12 + view.getMonth();
      if(calPrev) calPrev.disabled = !!min && vm <= min.getFullYear() * 12 + min.getMonth();
      if(calNext) calNext.disabled = !!max && vm >= max.getFullYear() * 12 + max.getMonth();
      if(focusKey){
        var f = calDays.querySelector('[data-d="' + focusKey + '"]');
        if(f && !f.disabled){
          calDays.querySelectorAll('[data-d]').forEach(function(x){ x.tabIndex = -1; });
          f.tabIndex = 0;
          f.focus();
        }
      }
    }
    function pickDay(key){
      date.value = key;
      var e = errEl('send_on');
      if(e){ e.hidden = true; e.textContent = ''; }
      date.removeAttribute('aria-invalid');
      drawCal();
      noteDate();
      foldCal(true);
      date.dispatchEvent(new Event('input', { bubbles: true }));
    }
    function moveView(by, focusKey){
      view = new Date(view.getFullYear(), view.getMonth() + by, 1);
      drawCal(focusKey);
    }
    /* empty again after an add, ready for the next card */
    function resetTo(){
      fields.forEach(function(f){ f.value = ''; });
      idea = '';
      root.querySelectorAll('[data-c4ugc-idea]').forEach(function(b){ b.classList.remove('c4ugc__idea--on'); });
      setWhen('now');
      clearErrors();
      updateCount();
    }

    /* a date from today to 90 days on, in the shopper's own calendar (Shopify's limit for "Send on") */
    if(date){
      var now = new Date();
      date.min = ymd(now);
      date.max = ymd(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 90));
    }
    if(cal && calDays && date){
      root.classList.add('c4ugc--cal');
      calDays.addEventListener('click', function(e){
        var b = e.target.closest && e.target.closest('[data-d]');
        if(b && !b.disabled) pickDay(b.getAttribute('data-d'));
      });
      calDays.addEventListener('keydown', function(e){
        var b = e.target.closest && e.target.closest('[data-d]');
        var step = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[e.key];
        if(!b || !step) return;
        e.preventDefault();
        var d = parse(b.getAttribute('data-d'));
        d.setDate(d.getDate() + step);
        var min = parse(date.min), max = parse(date.max);
        if((min && d < min) || (max && d > max)) return;
        if(d.getMonth() !== view.getMonth() || d.getFullYear() !== view.getFullYear()) moveView(d.getMonth() - view.getMonth() + (d.getFullYear() - view.getFullYear()) * 12, ymd(d));
        else drawCal(ymd(d));
      });
      if(calPrev) calPrev.addEventListener('click', function(){ moveView(-1); });
      if(calNext) calNext.addEventListener('click', function(){ moveView(1); });
      cal.addEventListener('keydown', function(e){
        if(e.key === 'Escape' && date.value) foldCal(true);
      });
      /* the pill pressed while it already shows a day: open or fold the month (a first press is the radio's change) */
      if(dateR) dateR.addEventListener('click', function(){
        if(to && to.classList.contains('c4ugc__to--date') && date.value) foldCal(!to.classList.contains('c4ugc__to--folded'));
      });
      drawCal();
      noteDate();
    }
    if(ifPresent) ifPresent.disabled = true;
    if(send) send.checked = true;
    if(offset){
      offset.disabled = false;
      offset.value = String(new Date().getTimezoneOffset());
    }
    whens.forEach(function(r){
      r.addEventListener('change', function(){ if(r.checked) setWhen(r.value, true); });
    });
    var startWhen = whens.filter(function(r){ return r.checked; })[0];
    setWhen(date && date.value ? 'date' : startWhen ? startWhen.value : 'now');
    if(cal && calDays && date && date.value && to) to.classList.add('c4ugc__to--folded');
    /* a note idea fills the message (or adds to what they wrote), then the card's gift tag shows it */
    root.querySelectorAll('[data-c4ugc-idea]').forEach(function(b){
      b.addEventListener('click', function(){
        if(!msg) return;
        var text = b.getAttribute('data-c4ugc-idea');
        var now = msg.value.trim();
        var max = msg.maxLength > 0 ? msg.maxLength : 200;
        msg.value = (!now || now === idea ? text : now + ' ' + text).slice(0, max);
        idea = text;
        root.querySelectorAll('[data-c4ugc-idea]').forEach(function(o){ o.classList.toggle('c4ugc__idea--on', o === b); });
        msg.dispatchEvent(new Event('input', { bubbles: true }));
        msg.focus();
        try{ msg.setSelectionRange(msg.value.length, msg.value.length); }catch(err){}
      });
    });
    updateCount();
    if(msg) msg.addEventListener('input', function(){
      updateCount();
      if(idea && msg.value.indexOf(idea) === -1){
        root.querySelectorAll('.c4ugc__idea--on').forEach(function(o){ o.classList.remove('c4ugc__idea--on'); });
      }
    });
    fields.forEach(function(f){
      f.addEventListener('input', function(){
        var key = f.getAttribute('data-c4ugc-in'), e = errEl(key);
        if(e && !e.hidden){ e.hidden = true; e.textContent = ''; f.removeAttribute('aria-invalid'); }
      });
    });

    form.addEventListener('change', function(e){
      if(e.target && e.target.name === 'id') pick(true);
    });
    /* choose by card: the small cards under the big one, and the "Send £25" buttons further down the page */
    function choose(id){
      var r = form.querySelector('input[name="id"][value="' + id + '"]');
      if(!r || r.disabled) return false;
      if(!r.checked){
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }
    root.querySelectorAll('[data-c4ugc-thumb]').forEach(function(b){
      b.addEventListener('click', function(){ choose(b.getAttribute('data-c4ugc-thumb')); });
    });
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('[data-c4ugc-pick]');
      if(!a || root.contains(a)) return;
      var id = a.getAttribute('data-c4ugc-pick');
      if(!form.querySelector('input[name="id"][value="' + id + '"]')) return;
      e.preventDefault();
      var top = root.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: Math.max(0, top), behavior: REDUCE ? 'auto' : 'smooth' });
      /* change once the band is back on screen, so the pop and the splash are seen */
      setTimeout(function(){ choose(id); }, REDUCE ? 0 : 520);
    });

    function setQty(n){
      n = parseInt(n, 10);
      if(!(n >= 1)) n = 1;
      if(n > 99) n = 99;
      qtyIn.value = n;
    }
    if(qtyIn){
      root.querySelectorAll('[data-c4ugc-q]').forEach(function(b){
        b.addEventListener('click', function(){ setQty((parseInt(qtyIn.value, 10) || 1) + Number(b.getAttribute('data-c4ugc-q'))); });
      });
      qtyIn.addEventListener('change', function(){ setQty(qtyIn.value); });
    }

    /* the card goes to them only with their email; with nothing typed at all it comes to the buyer */
    function forThem(){ return filled('email'); }
    function check(){
      var email = field('email');
      if(email){
        email.value = email.value.trim();
        if(!email.value){
          if(!filled('name') && !filled('send_on')) return true;
          showError('email', 'Add their email so we can send it to them.');
          email.focus();
          return false;
        }
        if(!email.checkValidity()){
          showError('email', 'Enter a full email address, like name@email.com.');
          email.focus();
          return false;
        }
      }
      if(date && date.value && (date.value < date.min || date.value > date.max)){
        showError('send_on', 'Pick a date from today up to 90 days ahead.');
        date.focus();
        return false;
      }
      return true;
    }

    form.addEventListener('submit', async function(e){
      e.preventDefault();
      if(pending || addLocked) return;
      clearErrors();
      if(!check() || (video && !video.valid())){
        setStatus('Check the details above.', true);
        return;
      }
      if(!video){ setStatus('Please reload the page so we can prepare your gift card.', true); return; }
      if(qtyIn) setQty(qtyIn.value);
      var data = new FormData(form);
      data.delete('c4ugc_when');
      if(!forThem()){
        if(msg && msg.value.trim()) data.set('properties[Gift message]', msg.value.trim());
        RECIPIENT.forEach(function(name){ data.delete(name); });
      }
      OPTIONAL.forEach(function(name){
        if(data.has(name) && !String(data.get(name)).trim()) data.delete(name);
      });
      pending = true;
      freeze(true);
      syncAtc();
      try{
        await video.add(data, function(text){ setStatus(text); });
        setStatus('Added to your basket.');
        resetTo();
        video.reset();
        document.dispatchEvent(new CustomEvent('candy:cart:added'));
      }catch(error){
        var errs = error.body && error.body.errors, shown = false;
        if(errs && typeof errs === 'object'){
          Object.keys(errs).forEach(function(key){
            if(!errEl(key)) return;
            var text = [].concat(errs[key]).join(', ');
            text = /^[a-z]/.test(text) ? NAMES[key] + ' ' + text : text;
            showError(key, /[.!?]$/.test(text) ? text : text + '.');
            shown = true;
          });
        }
        setStatus(shown ? 'Check the details above.' : error.message || 'Your gift card could not be added.', true);
        if(error.review){
          addLocked = true;
          var link = document.createElement('a');
          link.className = 'c4ugc__review'; link.href = cartRoot + 'cart'; link.textContent = ' Review your basket';
          status.appendChild(link);
        }
      }finally{
        pending = false;
        if(!addLocked) freeze(false);
        syncAtc();
      }
    });

    /* BACK: as on the product page (sections/candy-product.liquid). From a page on this site it goes back there
       and names it; from anywhere else it is a plain link to the gifts page. */
    var back = root.querySelector('[data-c4ugc-back]');
    if(back){
      var same = false, rp = '';
      try{
        var ref = new URL(document.referrer);
        rp = ref.pathname;
        same = ref.host === window.location.host && rp !== window.location.pathname && !/^\/(password|challenge|account\/log)/.test(rp);
      }catch(err){}
      var bt = back.querySelector('[data-c4ugc-back-t]');
      if(same && bt){
        if(/\/products\//.test(rp)){ bt.textContent = 'Back'; }
        else{
          var n = '';
          try{ n = window.sessionStorage.getItem('c4u-pname:' + rp) || ''; }catch(err){}
          if(!n){
            if(rp === '/' || rp === '') n = 'Home';
            else n = decodeURIComponent(rp.split('/').filter(Boolean).pop() || '').replace(/[-_]+/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
          }
          bt.textContent = n ? 'Back to ' + n : 'Back';
        }
      }
      back.addEventListener('click', function(e){
        if(same && window.history.length > 1){ e.preventDefault(); window.history.back(); }
      });
    }

    shown = chosen();
    syncAtc();
  }

  function boot(){ document.querySelectorAll('[data-c4ugc]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
